import React, { createContext, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PATH_INFO } from "../pages/utils/helper";

type UserType = {
  email: string
  department_name: string
}

const defaultUser: UserType = {
  email: '',
  department_name: ''
}

export const UserContext = createContext<{
  user: UserType
  isAuth: boolean | undefined
}>({
  user: defaultUser,
  isAuth: undefined
})

export const UpdateUserContext = createContext<{
  refreshUser: () => Promise<void>
  setIsAuth: (bol: boolean) => void
}>({
  refreshUser: async () => { },
  setIsAuth: (bol: boolean) => { }
})

export function useUserContext() {
  const [user, setUser] = useState({ email: '', department_name: '' })
  const [isAuth, setIsAuth] = useState<boolean | undefined>(undefined)
  const navigate = useNavigate()

  const refreshUser = useCallback(async () => {
    if (!sessionStorage.getItem('token')) {
      setUser({ email: 'ゲストユーザー', department_name: '' })
      setIsAuth(false)
      return
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/apis/client/user`, {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      })
      if (res.status === 401) {
        setUser({ email: 'ゲスト', department_name: '' })
        setIsAuth(false)
        return
      } else if (res.status === 403) {
        sessionStorage.removeItem('token')
        navigate(PATH_INFO.LOGIN.PATH)
        return
      }

      const data = await res.json();
      setUser(data)
      setIsAuth(true)
    } catch (error) {
      console.error("Error fetching user.");
      setIsAuth(false)
    }
  }, [navigate])

  useEffect(() => {
    refreshUser()
  }, [refreshUser])

  return {
    user,
    isAuth,
    refreshUser,
    setIsAuth
  }
}

export function UserProvider({ children }: { children: React.ReactNode }) {
  const { user, isAuth, refreshUser, setIsAuth } = useUserContext()

  return (
    <UpdateUserContext.Provider value={{ refreshUser, setIsAuth }}>
      <UserContext.Provider value={{ user, isAuth }}>
        {children}
      </UserContext.Provider>
    </UpdateUserContext.Provider>
  )
}